export default __webpack_public_path__ + "static/media/img_num_1.08071da7.png";